<app-deliverables-route [displayedColumns]="displayedColumns" [nodeId]="nodeId$ | async"></app-deliverables-route>
